module.exports = __webpack_public_path__ + "img/MultipleSelect.f022e79f.svg";